export const roleOptions = [
  { label: "Doctor", value: "doctor" },
  { label: "Patient", value: "patient" },
  { label: "Nurse", value: "nurse" },
  { label: "Lab Technician", value: "lab_technician" },
  { label: "Pharmacist", value: "pharmacist" },
  { label: "Physiotherapist", value: "physiotherapist" },
  { label: "Dietician", value: "dietician" },
  { label: "Caregiver", value: "caregiver" },
];
